import Dialog from '@/components/Dialog'
import { MembershipResponse } from '@/lib/definitions/api.types'
import { useCompanySelection } from '@/lib/hooks/useCompanySelection'
import { noop } from '@/lib/misc/Utils'
import { CompanyCard } from '@/pages/settings/partials/CompanyOnboarding'

const CompanyChooser = () => {
  const { memberships, selectCompany } = useCompanySelection()

  const onChoose = (membership: MembershipResponse) => {
    selectCompany(membership, { goHome: false })
  }

  return (
    <Dialog
      title="Choose a company"
      message="You belong to more than one company. Pick the one you want to work in — you can switch later."
      hasButtons={false}
      dismissOnBackdrop={false}
      onConfirm={noop}
      onDismiss={noop}
    >
      <ul data-cy="company-chooser" className="mt-5 space-y-2">
        {memberships.map((membership) => (
          <li key={membership.customer_id}>
            <button
              type="button"
              data-cy="company-chooser-option"
              onClick={() => onChoose(membership)}
              className="group block w-full cursor-pointer rounded-xl text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-100"
            >
              <CompanyCard
                name={membership.name}
                className="transition-colors group-hover:border-accent-30 group-hover:bg-accent-05"
              />
            </button>
          </li>
        ))}
      </ul>
    </Dialog>
  )
}

export default CompanyChooser
